import { defineCatalogue } from '../../i18n';

export const entityCatalogue = defineCatalogue(
  {
    recent: 'Recentes',
    loading: 'Carregando a lista',
    failed: 'Não foi possível carregar a lista. Recarregue a página para tentar de novo.',
  },
  {
    recent: 'Recent',
    loading: 'Loading the list',
    failed: 'The list could not load. Reload the page to try again.',
  },
);

export const et = entityCatalogue.t;
